import React, { useState, useRef, KeyboardEvent } from 'react';
import { useAuth } from './Auth';
import { TextField, Button, Container, Typography, Box, ThemeProvider, createTheme } from '@mui/material';
import './styles/Login.css';
import { palette } from './styles/colors';

const theme = createTheme({
    palette: {
        primary: palette.primary,
        secondary: palette.secondary,
    },
});

const Login: React.FC = () => {
    const { user, login } = useAuth();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState<string | null>(null);
    const passwordRef = useRef<HTMLInputElement>(null);

    const handleLogin = async () => {
        try {
            await login(username, password);
        } catch (error) {
            setMessage('Login failed');
        }
    };

    const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            if (document.activeElement === passwordRef.current) {
                handleLogin();
            } else {
                passwordRef.current?.focus();
            }
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <Container maxWidth="xs">
                {user ? (
                    <Typography variant="h6" className="logged-in-message">
                        Already logged in as {user.Username}
                    </Typography>
                ) : (
                    <Box className="login-container">
                        <Typography component="h1" variant="h5">
                            Login
                        </Typography>
                        <Box component="form" noValidate className="login-form">
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="username"
                                label="Username"
                                name="username"
                                autoComplete="username"
                                autoFocus
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                onKeyDown={handleKeyDown}
                                className="login-input"
                            />
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                inputRef={passwordRef}
                                onKeyDown={handleKeyDown}
                                className="login-input"
                            />
                            <Button
                                type="button"
                                fullWidth
                                variant="contained"
                                className="login-button"
                                onClick={handleLogin}
                                color="primary"
                            >
                                Login
                            </Button>
                            {message && (
                                <Typography color="error" align="center">
                                    {message}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                )}
            </Container>
        </ThemeProvider>
    );
};

export default Login;
